export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    if($('.categories-featured').length) {
      var movementStrength = 10;
      var height = movementStrength / $(window).height();
      var width = movementStrength / $(window).width();
      $('.categories-featured').mousemove(function(e){
        var pageX = e.pageX - ($(window).width() / 2);
        var pageY = e.pageY - ($(window).height() / 2);
        var newvalueX = width * pageX * -1;
        var newvalueY = height * pageY * -1 / 2; //moving between ~ -15px to +15px
        $(this).find('.illustration__hero--bird-up').css('transform', `translate(${-newvalueX}px, ${-newvalueY * 1.3}px)`);
        $(this).find('.illustration__hero--bird-right').css('transform', `translate(${newvalueX * 2}px, ${newvalueY}px)`);
        $(this).find('.illustration__hero--bird-right-outer').css('transform', `translate(${newvalueX  / 2}px, ${newvalueY / 2}px)`);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js